// AppStoreBadge.jsx
import { Badge, Image } from '@chakra-ui/react';
import appStoreBadge from '../assets/appStoreBadge.png';

const AppStoreBadge = () => (
  <Badge colorScheme="green">
    <Image src={appStoreBadge} alt="App Store" width={32} />{' '}
  </Badge>
);

export default AppStoreBadge;
